import { Box, Typography, Button, SxProps, Theme } from "@mui/material";
import { SectionContainer } from "../../../modules/SectionContainer/SectionContainer";
import { SectionTitle } from "../../../modules/SectionTitle/SectionTitle";

const voices = [
  {
    initial: "A",
    name: "Aさん",
    role: "新卒入社 / エンジニア",
    comment:
      "学生のころからインターンで関わっていたので、入社したときにはすでに現場の感覚がついていました。いきなり難しいことを任されるわけじゃなくて、自分のレベルに合った仕事から始められる。できることが増えるたびに次のステージに進んでいく感じがあって、成長がちゃんと見えるのが一番のモチベーションになっています。",
  },
  {
    initial: "B",
    name: "Bさん",
    role: "中途入社 / エンジニア",
    comment:
      "前の会社ではずっとシステムテストだけで、開発に移れるって言われていたのに結局そのままでした。テクノスタンダードに来てから初めて、設計から実装・リリースまで自分でやり切る経験ができた。自社開発でしっかり基礎を固められたのが、今の外部案件でも自信につながっています。この前クライアントの方から『優秀ですね』って言ってもらえたときは、本当に転職してよかったと思いました。",
  },
  {
    initial: "C",
    name: "Cさん",
    role: "中途入社 / シニアエンジニア",
    comment:
      "代表とはドワンゴ時代の同僚で、会社を立ち上げたって聞いて。ベンチャーで新しいことをやってみたいという気持ちもあって飛び込みました。今は若手が正しい開発を身につけられるように設計やレビューを丁寧にやっています。詰まっているときに横でちょっと手本を見せると、後から『あのときわかりました』って言ってくれる瞬間があって、それが一番うれしい。技術に自由な会社なので、大きい案件も小さい案件も、自分にとってもすごく刺激になっています。",
  },
];

export const VoicesSection = () => {
  const scrollToRequirements = () => {
    const element = document.getElementById("requirements-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <SectionContainer sx={{ background: "#FFFFFF", padding: { md: "100px 0", xs: "60px 0" } }}>
      <SectionTitle sx={{ fontSize: { md: "40px", xs: "26px" } }}>メンバーの声</SectionTitle>

      <Box sx={cardsContainerSx}>
        {voices.map((voice, index) => (
          <Box key={index} sx={cardSx}>
            <Box sx={avatarSx}>
              <Typography sx={initialSx}>{voice.initial}</Typography>
            </Box>
            <Typography sx={nameSx}>{voice.name}</Typography>
            <Typography sx={roleSx}>{voice.role}</Typography>
            <Typography sx={commentSx}>「{voice.comment}」</Typography>
          </Box>
        ))}
      </Box>

      <Box sx={ctaContainerSx}>
        <Button sx={ctaButtonSx} onClick={scrollToRequirements}>
          エントリーする
        </Button>
      </Box>
    </SectionContainer>
  );
};

const cardsContainerSx: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { md: "repeat(3, 1fr)", xs: "1fr" },
  gap: { md: "24px", xs: "20px" },
  marginTop: { md: "48px", xs: "32px" },
};

const cardSx: SxProps<Theme> = {
  background: "#f8f9fa",
  borderRadius: "12px",
  padding: { md: "32px", xs: "24px" },
  textAlign: "center",
  transition: "all 0.3s",
  "&:hover": {
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.08)",
  },
};

const avatarSx: SxProps<Theme> = {
  width: "80px",
  height: "80px",
  borderRadius: "50%",
  background: "#22A1B9",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto 16px",
};

const initialSx: SxProps<Theme> = {
  fontSize: "28px",
  fontWeight: 700,
  color: "#FFFFFF",
};

const nameSx: SxProps<Theme> = {
  fontSize: { md: "18px", xs: "16px" },
  fontWeight: 700,
  color: "#222222",
  marginBottom: "4px",
};

const roleSx: SxProps<Theme> = {
  fontSize: { md: "13px", xs: "12px" },
  color: "#666666",
  marginBottom: "16px",
};

const commentSx: SxProps<Theme> = {
  fontSize: { md: "14px", xs: "13px" },
  color: "#333333",
  lineHeight: 1.9,
  textAlign: "left",
};

const ctaContainerSx: SxProps<Theme> = {
  marginTop: { md: "48px", xs: "32px" },
  textAlign: "center",
};

const ctaButtonSx: SxProps<Theme> = {
  background: "linear-gradient(135deg, #22A1B9, #00BFA5)",
  color: "#FFFFFF",
  fontWeight: 700,
  padding: { md: "16px 48px", xs: "14px 40px" },
  fontSize: { md: "16px", xs: "15px" },
  borderRadius: "8px",
  textTransform: "none",
  transition: "all 0.3s",
  boxShadow: "0 4px 15px rgba(34, 161, 185, 0.3)",
  "&:hover": {
    background: "linear-gradient(135deg, #1d8fa3, #00a890)",
    transform: "translateY(-2px)",
    boxShadow: "0 8px 25px rgba(34, 161, 185, 0.4)",
  },
};
